import { createContext, useContext } from 'react';

/**
 * Provides the active collection record (as loaded by CollectionsLayout)
 * to any nested routes/components that need it.
 */
export const CollectionContext = createContext(null);

export function useCollectionContext() {
	return useContext(CollectionContext);
}
